<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5 9V6C5 4.34315 6.34315 3 8 3H16C17.6569 3 19 4.34315 19 6V9H20C21.6569 9 23 10.3431 23 12V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V12C1 10.3431 2.34315 9 4 9H5ZM8 5H16C16.5523 5 17 5.44772 17 6V19H7V6C7 5.44772 7.44772 5 8 5ZM5 11H4C3.44772 11 3 11.4477 3 12V18C3 18.5523 3.44772 19 4 19H5V11ZM19 19H20C20.5523 19 21 18.5523 21 18V12C21 11.4477 20.5523 11 20 11H19V19Z"
    fill="currentColor"
  />
  <path
    d="M10 17C10 16.4477 10.4477 16 11 16H13C13.5523 16 14 16.4477 14 17V21H10V17Z"
    fill="currentColor"
  />
  <path
    d="M12 7C11.4477 7 11 7.44772 11 8V9H10C9.44771 9 9 9.44771 9 10C9 10.5523 9.44771 11 10 11H11V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V11H14C14.5523 11 15 10.5523 15 10C15 9.44772 14.5523 9 14 9H13V8C13 7.44772 12.5523 7 12 7Z"
    fill="currentColor"
  />
</svg>
